'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('piperGuestList', {
      url: '/piper/guest/list',
      template: '<piper-guest-list></piper-guest-list>'
    });
}



// WEBPACK FOOTER //
// ./client/app/piper/guest/list/guest.routes.js